import {
  UpdateSourceRequest,
  UpdateSourceResponse,
} from "@gx/ts-contracts/services/source/api/source_pb";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import { SourceFormError } from "@/pages/sources/components/types";

export enum EditSourceDrawerTab {
  OVERVIEW = "overview",
  CONTENT = "content",
  ARTIFACTS = "artifacts",
  SYNCS = "syncs",
  SETTINGS = "settings",
}

/**
 * Form data for editing a source.
 * Uses MessageInitShape to derive the correct type from the protobuf schema.
 */
export interface EditSourceFormState {
  /**
   * What's the current source resource?
   */
  source: SourceResource;

  /**
   * What's the loading state for the source editing flow?
   */
  isLoading: boolean;

  /**
   * Did the update source succeed?
   */
  isUpdateSourceSucceeded: boolean;

  /**
   * Should the error messages be shown?
   */
  shouldShowErrors: boolean;

  /**
   * What are the current form validation errors?
   */
  errors: SourceFormError[];

  /**
   * What's the current update source request?
   */
  updateSourceRequest: UpdateSourceRequest;

  /**
   * What's the current update source response for the source editing flow?
   */
  updateSourceResponse: UpdateSourceResponse;
}
